export const meta = {
  title: '服务目录:您卖什么,按车型定价',
  updatedAt: '2026-07-17',
  related: ['branding', 'pos'],
};

从排队看板顶栏打开**目录**。四个标签页——**套餐**、**服务**、**加购项**、**车型**——定义了顾客能预订的一切和对应价格。您的账号自带一套合理的初始配置,不必从零搭建:您改的是名称、价格和可用范围。在这个页面新增和删除条目的功能即将推出。

## 一份目录,所有门店

目录挂在企业层面,不是每家门店一份。改一次套餐,每家门店同步生效。如果您经营多家门店,每个条目会显示**可用门店**列表——默认全部勾选,把不该出现该条目的门店取消勾选即可。新门店自动获得完整目录。

## 四种积木

- **服务**是原子工序——外部清洗、吸尘、打蜡。每项有名称和分钟数时长。服务本身不带价格。
- **套餐**把服务打包在一起,是顾客实际预订的东西。每个套餐有价格、预计时长,还可标记**主推**,在预订流程中脱颖而出。
- **加购项**是带价格的附加品,顾客(或收银员在 POS 上)可以加到单子上——发动机舱清洗、内饰消毒。
- **车型**是定价的基准尺寸——轿车、SUV、MPV。顾客预订时选择自己的车型。

## 按车型定价

套餐和加购项不是一口价:每一项都有一张价格表,每个启用中的车型对应一格 **RM** 输入框。同一套餐,SUV 版可以比轿车版贵。某个车型留空,该项就干脆不对那种车提供。

## 按门店覆盖价格

套餐支持不同门店不同价。在**按门店价格覆盖**下,勾选**在 [门店] 覆盖价格**,只填有差异的格子——留空的一律回落到默认价。套餐卡片一眼就能看出有几家门店在用自定义价格。

## 隐藏条目

取消勾选**启用**并保存,该条目就从所有菜单下架——目录里显示*已隐藏*标记,顾客预订中消失,但历史记录原封不动。再勾回来即可恢复。这也是安全网:条目只能被隐藏或从门店排除,绝不会被误删。

## 名称与语言

目录编辑器目前编辑的是**英文**显示名;条目已有的其他语言翻译原样保留。按语言编辑的功能将在后台跟进。

## 预付洗车包在别处

一个命名陷阱:这里的套餐是单次消费的组合。**预付洗车包**——一次付清 5 次洗车,或每月不限次——是另一种东西,在**洗车订阅套餐**页面管理(顾客档案上的**设置洗车包**按钮可以带您过去)。洗车包有自己的价格、有效期,和一句您自己撰写的省钱提示("比单次付费省 RM 25")。顾客在您的应用里或柜台购买,之后每次到店在 POS 核销一次洗车。
